document.addEventListener('click', event => {
  const link = event.target instanceof Element ? event.target.closest('a') : null;
  document.querySelectorAll('.alm-navigation--desktop details[open],.alm-mobile-navigation>details[open]').forEach(details => {
    if (!details.contains(event.target) || (link && details.contains(link))) details.open = false;
  });
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  const details = event.target.closest('.alm-navigation details[open],.alm-mobile-navigation>details[open]');
  if (details) {details.open=false;details.querySelector('summary').focus();}
});
document.querySelectorAll('.alm-navigation--desktop details').forEach(details => details.addEventListener('toggle', () => {
  if (details.open) document.querySelectorAll('.alm-navigation--desktop details[open]').forEach(other => {if (other !== details) other.open=false;});
}));

(() => {
  const icons = '.alm-ui-arrow,.alm-icon-arrow,.alm-line-arrow';
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const timers = new WeakMap();
  const pulse = control => {
    if (!control || motion.matches || control.matches(':disabled,[aria-disabled="true"]') || !control.querySelector(icons)) return;
    window.clearTimeout(timers.get(control));
    control.classList.remove('alm-arrow-active');
    requestAnimationFrame(() => {
      if (!control.isConnected || motion.matches) return;
      control.classList.add('alm-arrow-active');
      timers.set(control, window.setTimeout(() => control.classList.remove('alm-arrow-active'), 400));
    });
  };
  document.addEventListener('pointerdown', event => {
    if (!(event.target instanceof Element) || (event.pointerType === 'mouse' && event.button !== 0)) return;
    const control = event.target.closest('a,button,summary');
    pulse(control?.querySelector(icons) ? control : event.target.closest('almeora-storage-compare'));
  }, { passive: true });
  document.addEventListener('keydown', event => {
    if (!(event.target instanceof Element) || event.repeat) return;
    const compare = event.target.closest('almeora-storage-compare');
    if (compare && ['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) pulse(compare);
    if (event.key === 'Enter' || event.key === ' ') pulse(event.target.closest('a,button,summary'));
  });
})();
